import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Picture } from 'components/UI';
import { gfxSubscription } from 'assets';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 16,
    minWidth: 192,
    borderRadius: 18,
    border: '4px solid #47B6CC',
    boxShadow: '0 20px 25px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden',
    backgroundColor: '#F3F5F7',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '16px',
    gap: 4,
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'fit-content',
    padding: '8px 20px',
    borderRadius: 999,
    backgroundColor: '#D8EEF3',
  },
  badgeText: {
    color: '#287F9C',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1,
    letterSpacing: '0.08em',
  },
  priceRow: {
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: 4,
  },
  amount: {
    color: '#214061',
    fontSize: 64,
    lineHeight: 0.95,
    fontWeight: 600,
  },
  duration: {
    color: '#214061',
    fontSize: 20,
    lineHeight: 1.1,
    marginLeft: 8,
    marginBottom: 8,
    fontWeight: 400,
  },
  billingText: {
    color: '#214061',
    fontSize: 18,
    lineHeight: 1.3,
    marginTop: 8,
    minHeight: 24,
    fontWeight: 400,
  },
  image: {
    height: 40,
    width: '100%',
    objectFit: 'cover',
  },
}));

const PricingCycle = ({ amount, isAnnual = false }) => {
  const classes = useStyles();

  const planLabel = isAnnual ? 'ANNUAL PLAN' : 'MONTHLY PLAN';
  const billingText = isAnnual ? 'Billed Annually' : 'Billed Monthly';
  const durationText = isAnnual ? 'USD/year' : 'USD/month';

  return (
    <div className={classes.container} role="presentation">
      <div className={classes.content}>
        <div className={classes.badge}>
          <span className={classes.badgeText}>{planLabel}</span>
        </div>

        <div className={classes.priceRow}>
          <span className={classes.amount}>{amount}</span>
          <span className={classes.duration}>{durationText}</span>
        </div>

        <div className={classes.billingText}>{billingText}</div>
      </div>

      <Picture src={gfxSubscription} className={classes.image} />
    </div>
  );
};

PricingCycle.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isAnnual: PropTypes.bool,
};

export default PricingCycle;